import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { inventoryByPlantResponse } from 'src/app/pages/orders/order-taking/components/new-order/models/iExtraProductFilters';
import { EndpointConstants } from '@core/services/endpoints-configurations/endpoint-constants';

@Injectable({ providedIn: 'root' })
export class InventoryByPlantApiService {
  private headers = new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set('Ocp-Apim-Subscription-Key', environment.apimSubscriptionKey);

  private baseUrlStockPlants = `${EndpointConstants.ApiOnHandInventory}`;

  constructor(private http: HttpClient) {}

  getInventory(productCode: string, plants: string[]): Observable<inventoryByPlantResponse[]> {
    const list = (plants || []).join('&plantCode=');
    const url = `${this.baseUrlStockPlants}?productCode=${productCode}&plantCode=${list}`;
    return this.http.get<inventoryByPlantResponse[]>(url, { headers: this.headers });
  }
}
